import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static values = { disableAfterSubmit: Boolean }

  submit() {
    Rails.fire(this.element, 'submit')
    if (this.disableAfterSubmitValue) {
      this.disableForm()
    }
  }

  disableForm() {
    this.element.querySelectorAll("input, button, select, textarea").forEach((element) => {
      element.disabled = true
    })
  }
}
